/* Newsletter article behaviour: "Kopier dette nyhetsbrevet" copies the article link. */
(function () {
  var btn = document.querySelector('[data-copy-link]');
  if (!btn) return;

  var label = btn.querySelector('.ubevisst-nl-article__copy-label');
  var original = label ? label.textContent : '';

  btn.addEventListener('click', async function () {
    var url = btn.dataset.url || window.location.href;

    try {
      await navigator.clipboard.writeText(url);
    } catch (e) {
      var ta = document.createElement('textarea');
      ta.value = url;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (_) {}
      document.body.removeChild(ta);
    }

    if (label) {
      label.textContent = btn.dataset.copiedLabel || 'Kopiert!';
      setTimeout(function () { label.textContent = original; }, 2000);
    }
  });
})();
